/** @jsxImportSource @emotion/react */

import { useMutation } from '@apollo/client'
import Typography from '@mui/material/Typography'
import { createSearchParams, useSearchParams } from 'react-router-dom'
import slugify from 'slugify'
import { PlatformSlug } from 'constants/consts'

import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import { CreateReward, CreateRewardVariables } from '__generatedTypes__/CreateReward'
import { CREATE_REWARD } from 'queries/rewards'
import withPlatformCheck from 'HOCs/withPlatformCheck'
import { cmsRoutes, useLink } from 'routes/cmsRoutes'

import { toast } from 'utils/toast'
import * as classes from '../../styles'
import { AwardsTabs, QUERY_PARAM, ORDER_PARAM } from '../../consts'
import { Form, FormValues } from './Form'
import { getValue } from './utils'

type Props = {
  platform: Platform
}

export const RewardCreate = withPlatformCheck(({ platform }: Props) => {
  const [searchParams] = useSearchParams()
  const { navigate } = useLink()

  const [createReward] = useMutation<CreateReward, CreateRewardVariables>(CREATE_REWARD)

  const handleSubmit = async (values: FormValues) => {
    try {
      const order = Number(searchParams.get(ORDER_PARAM))
      await createReward({
        variables: {
          createInput: {
            type: values.type.id,
            percentage: Number(values.mysteryBoxPercentage),
            platform: { id: platform.id },
            isLive: false,
            description: values.description,
            value: getValue(values),
            order: order ? order + 1 : 0,
          },
        },
      })

      navigate(cmsRoutes.ACHIEVEMENTS, undefined, {
        searchParams: createSearchParams({
          [QUERY_PARAM]: slugify(AwardsTabs.REWARDS, { lower: true }),
        }),
      })

      toast.success('Reward created successfully')
    } catch (error) {
      toast.error('Failed to create reward')
    }
  }

  return (
    <section css={classes.container}>
      <Typography css={classes.title} variant="title3">
        Rewards
      </Typography>
      <Form onSubmit={handleSubmit} platform={platform.slug as PlatformSlug} />
    </section>
  )
})
